export const MAX_AMOUNT_AVATARS = 3;

export const UNKNOWN_INITIAL = '?';
